// Extract and organize BEGES scope numbers into a parent-child structure

import { TScope } from "@/types/scope";

// returns: [{parent: "1", children: ["1.1", "1.2"]}, {parent: "2", children: ["2.1"]}]
export function extractBegesScopeNumber(
  scopes: Array<TScope>
): Array<{ parent: string; children: Array<string> }> {
  return (
    scopes
      // Filter out scopes that do not have a BEGES number or have a single digit
      .filter(
        (scope) => scope.beges_number !== null && scope.beges_number.length > 1
      )
      // Sort scopes by BEGES number
      .sort((a, b) => a.beges_number.localeCompare(b.beges_number))
      .reduce(
        (acc: Array<{ parent: string; children: Array<string> }>, scope) => {
          const parentScope = scope.beges_number[0];
          const accIndex = acc.findIndex(
            (element) => element.parent === parentScope
          );

          if (accIndex !== -1) {
            acc[accIndex].children.push(scope.beges_number);
          } else {
            acc.push({
              parent: parentScope,
              children: [scope.beges_number],
            });
          }
          return acc;
        },
        []
      )
  );
}
